import React from 'react';
import { PropTypes as PT } from 'prop-types';
import Header from 'containers/InCall/InCallHeader/InCallHeaderContainer';
import Video from 'containers/InCall/CallLayout/CallLayoutContainer';
import Footer from 'containers/InCall/InCallFooter/InCallFooterContainer';
import NotificationPillContainer from 'containers/NotificationPill/NotificationPillContainer';
import classes from './CallViewHolder.module.scss';

/**
 * Top level call holder view. Simply contains the Header, Video, and Footer
 * elements.
 */
class CallViewHolder extends React.PureComponent {
  componentDidMount() {
    // close the whiteboard if the window is closed
    window.addEventListener('beforeunload', this.props.webappCloseWhiteboard);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.props.webappCloseWhiteboard);
    // close the whiteboard if the call ends
    this.props.webappCloseWhiteboard();
  }

  render() {
    return (
      <div className={classes.container}>
        <Header />
        <Video />
        <NotificationPillContainer inCall />
        <Footer />
      </div>
    );
  }
}

CallViewHolder.propTypes = {
  webappCloseWhiteboard: PT.func
};

export default (CallViewHolder);
